import React from "react"

export default function PrinterSelect() {
  return (
    <symbol id="svg-select-printer" viewBox="0 0 32 32">
      <path
        fill="currentColor"
        d="M26.3 6.8h-4.2V4.5c0-.4-.3-.8-.8-.8H10.7c-.4 0-.8.3-.8.8v2.3H5.7c-1.1 0-1.9.9-1.9 1.9v12.1c0 1.1.9 1.9 1.9 1.9h4.2v4.6c0 .4.3.8.8.8h10.6c.4 0 .8-.3.8-.8v-4.6h4.2c1.1 0 1.9-.9 1.9-1.9v-12c0-1.1-.8-2-1.9-2zm-5.7 19.9h-9.1v-9.2h9.1v9.2zM9.2 9.3v-1h.7v.9h-.7v.1zm2.2 0v-4h9.1v4h-9.1zm10.7 0v-1h.7v.9h-.7v.1zm0 8.2h.7c.4 0 .8-.3.8-.8s-.4-.7-.8-.7H9.2c-.4 0-.8.3-.8.8s.3.8.8.8h.7v3.8H5.7c-.2 0-.4-.2-.4-.4V8.8c0-.2.2-.4.4-.4h2V10c0 .4.3.8.8.8h15.1c.4 0 .8-.3.8-.8V8.3h2c.2 0 .4.2.4.4v12.1c0 .2-.2.4-.4.4h-4.2v-3.7h-.1zM7.2 12.8c-.5 0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9-.4-.9-.9-.9zm6.3 12.6h2.4c.4 0 .8-.3.8-.8s-.3-.8-.8-.8h-2.4c-.4 0-.8.3-.8.8s.4.8.8.8zm0-2.6h5c.4 0 .8-.3.8-.8s-.3-.8-.8-.8h-5c-.4 0-.8.3-.8.8s.4.8.8.8z"
      />
    </symbol>
  )
}
